import getConfig from "next/config";
import { parseCommaSeparatedString } from "@grandvisionhq/state";
const { publicRuntimeConfig } = getConfig();
const { ids, auth, preview } = publicRuntimeConfig.googleTagManager;
const gtmConfig = {
  ids: parseCommaSeparatedString(ids),
  auth: parseCommaSeparatedString(auth),
  preview: parseCommaSeparatedString(preview)
};
export {
  gtmConfig as g
};
//# sourceMappingURL=google-tag-manager.js.map
